// extracted by mini-css-extract-plugin
export var notificationHost = "_dj-0";